import { MenuItem } from 'primeng/api';

export const SIDEBAR_ITEMS: MenuItem[] = [
  {
    label: 'sidebar.hubs',
    icon: 'heroCog8Tooth',
    routerLink: ['/hubs'],
  },
  {
    label: 'sidebar.users',
    icon: 'heroUsers',
    routerLink: ['/users'],
  },
  {
    label: 'sidebar.admins',
    icon: 'heroShieldCheck',
    routerLink: ['/admins'],
  },
];
